module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Allaman-c097c54e4778e4f3a89698d9b1c1f262.svg";